import type { SVGProps } from 'react';

interface LogoPiece5IconProps {
  title?: string;
  titleId?: string;
  desc?: string;
  descId?: string;
}
export const LogoPiece5Icon = ({
  title,
  titleId,
  desc,
  descId,
  ...props
}: SVGProps<SVGSVGElement> & LogoPiece5IconProps) => (
  <svg
    {...props}
    aria-labelledby={titleId}
    fill="none"
    height="1em"
    role="img"
    viewBox="0 0 56 97"
    width="1em"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title id={titleId}>{title}</title>
    <g fill="#44C761" fillOpacity={0.25} opacity={0.3}>
      <path d="M24.21 17.46c18.816 14.894 30.894 37.968 30.894 63.88 0 5.613-.572 11.083-1.636 16.36-12.174 8.659-28.384 17.637-34.44 20.029-8.994 3.54-8.82.143-8.247-9.998.047-.989.11-2.057.158-3.189.239-5.167.366-11.641.318-20.937.89-13.076.588-19.758 1.796-24.43 1.24-4.736 2.829-13.283 6.071-24.286 2.257-7.622 4.275-14.479 5.086-17.429M16.391 11.975c-.381.32-.779.654-1.208.99-7.612 6.059-31.753 22.914-36.139 22.914s-10.982-1.58-17.02-15.723c-2.003-4.672-5.07-10.381-8.106-16.026-.254-.462-.508-.94-.763-1.403A81.1 81.1 0 0 1-25.978 0c15.527 0 30.02 4.37 42.337 11.96zM3.487 97.397c1.128 12.757 2.13 23.999-6.945 26.566-9.202 2.599-22.997 2.009-31.038 0-.97-.239-2.098-.51-3.322-.813-8.995-2.169-23.695-5.693-24.553-9.855-2.019-9.791-.573-21.32 1.144-32.833 1.732-11.529 2.304-14.112 5.022-15.85 1.398-.877 5.896-5.597 10.584-10.493 4.498-4.704 9.154-9.583 11.41-11.433 2.623-2.153 9.632 1.531 16.815 5.31L-2.6 54.247c4.831 2.041 6.134 15.755 5.896 28.894-.095 5.167-.175 10.078.143 13.73l.048.51zM9.809 47.229c2.098-5.406 10.457-27.698 5.371-26.183-5.07 1.499-35.805 21.192-29.067 23.44 1.192.399 8.773 3.03 10.092 3.524 6.134 2.297 11.871 3.684 13.604-.765z" />
    </g>
  </svg>
);
